<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style lang="scss">
@font-face {
    font-family: "bold";
    src: url('../src/assets/DIN-Bold.otf');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: "medium";
    src: url('../src/assets/DIN-Medium.otf');
    font-weight: normal;
    font-style: normal;
}
</style>
